import {NeighborhoodProps} from 'modules/neighborhoods/types';
import neighborhoodsKeys from 'modules/neighborhoods/util/neighborhoods-keys';
import React from 'react';
import List from 'shared/layout/list';
import ApiDeleteButton from 'shared/migration-components/api-delete-button';
import ApiSwitch from 'shared/migration-components/api-switch';
import useProjection from 'shared/migration-hooks/use-projection';
import toBrl from 'shared/util/to-brl';

const Neighborhoods: React.FC = () => {
  const projection = useProjection<NeighborhoodProps>('neighborhoods', [
    'name',
    'deliveryPrice',
    'deliveryManFee',
    'city.name',
    'active',
    'id',
  ]);

  return (
    <List<NeighborhoodProps>
      {...{
        titleBar: {
          title: 'Bairros',
          actionButton: {title: 'NOVA BAIRRO', to: 'create'},
        },
        table: {
          url: '/neighborhoods',
          projection: {
            ...projection,
            options: [
              'name',
              {
                value: 'deliveryPrice',
                filter: {valueAsNumber: true},
                column: (row) => row.deliveryPrice && toBrl(row.deliveryPrice),
              },
              {
                value: 'deliveryManFee',
                filter: {valueAsNumber: true},
                column: (row) =>
                  row.deliveryManFee && toBrl(row.deliveryManFee),
              },
              'city.name',
              {
                value: 'active',
                column: {
                  value: (row) => (
                    <ApiSwitch
                      isChecked={row.active}
                      url={`/neighborhoods/${row.id}`}
                      queryKey={neighborhoodsKeys.list()}
                    />
                  ),
                  stopPropagation: true,
                },
                filter: {
                  type: 'select',
                  values: [
                    {
                      label: 'Sim',
                      value: true,
                    },
                    {
                      label: 'Não',
                      value: false,
                    },
                  ],
                },
              },
              {
                label: 'Ações',
                value: 'id',
                column: (row) => (
                  <ApiDeleteButton
                    inifiteQuery
                    queryKey={neighborhoodsKeys.list()}
                    url={`/neighborhoods/${row.id}`}
                    field={row.id}
                    idKey="id"
                  />
                ),
              },
            ],
          },
          translatedPropsKey: 'NeighborhoodProps',
        },
        queryKey: neighborhoodsKeys.list(),
      }}
    />
  );
};

export default Neighborhoods;
